const mapping: Record<string, string> = {
  id: 't=>t.Id',
  name: 't=>t.Name',
}
export const mapSortTribuneParam = (key: string) => mapping[key]
